export const debounceIntervalExtraShort = 50;
export const debounceIntervalShort = 300;
export const debounceInterval = 600;
export const debounceIntervalMedium = 800;
export const debounceIntervalLong = 1000;
